import { LogLevel } from "@hotelchamp/common";
import { useEffect } from "react";

import { CheckoutActivityLog } from "./CheckoutActivityLog";
import { logLocation } from "./utils";

export interface IUseLogCheckoutItemPageProps {
    page: string;
    visitorId?: string;
    checkoutSessionId?: string;
    bookingId?: string;
    channelBookingId?: string;
    propertyId?: string;
    where?: string | null;
}

export const useLogCheckoutItemPage = ({
    page,
    visitorId,
    checkoutSessionId,
    bookingId,
    channelBookingId,
    propertyId,
    where,
}: IUseLogCheckoutItemPageProps) => {
    useEffect(() => {
        new CheckoutActivityLog({
            message: `Will mount page: ${page}`,
            visitorId,
            action: "load_page",
            checkoutSessionId,
            bookingId,
            channelBookingId,
            propertyId,
            where: where ?? logLocation(4),
        })
            .startGroup(`Render page: ${page}`)
            .queue(LogLevel.Info);

        return () => {
            new CheckoutActivityLog({
                message: `Will unmount page: ${page}`,
                visitorId,
                action: "load_page",
                checkoutSessionId,
                bookingId,
                channelBookingId,
                propertyId,
                where: where ?? logLocation(4),
            })
                .queue(LogLevel.Info)
                .endGroup();
        };
    }, []);
};
